// extracted by mini-css-extract-plugin
export default {"container":"W7eO_K","link":"w_d7X7","term":"QtFEB8"};